module.exports = __webpack_public_path__ + "img/sidebar_motion_sensor.6622546a.svg";